(() => {
  if (window.nhCardQuickAdd) return;
  window.nhCardQuickAdd = true;
  const refreshDrawer = () => new Promise((resolve) => {
    if (typeof window.SLIDECART_UPDATE !== 'function') return resolve(false);
    let settled = false;
    const finish = () => {
      if (settled) return;
      settled = true;
      clearTimeout(timeout);
      resolve(true);
    };
    const timeout = setTimeout(finish, 4000);
    try { window.SLIDECART_UPDATE(finish); } catch { finish(); }
  });
  document.addEventListener('submit', async (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('[data-nh-quick-add]')) return;
    event.preventDefault();
    if (form.hasAttribute('data-busy')) return;
    const button = form.querySelector('button[type="submit"]');
    const status = form.querySelector('[data-nh-quick-status]');
    const originalLabel = button.textContent;
    form.setAttribute('data-busy', '');
    form.removeAttribute('data-feedback');
    form.setAttribute('aria-busy', 'true');
    button.disabled = true;
    button.textContent = form.dataset.adding;
    status.textContent = '';
    let added = false;
    try {
      const url = new URL(form.action, location.origin);
      url.pathname = url.pathname.replace(/\/$/, '') + '.js';
      const response = await fetch(url, {
        method: 'POST', credentials: 'same-origin',
        headers: { Accept: 'application/json' }, body: new FormData(form)
      });
      const result = await response.json();
      if (!response.ok || result.status >= 400) {
        throw new Error(typeof result.description === 'string' ? result.description : form.dataset.error);
      }
      added = true;
      status.textContent = form.dataset.added;
      form.setAttribute('data-feedback', '');
      if (typeof window.SLIDECART_OPEN === 'function' && typeof window.SLIDECART_UPDATE === 'function') {
        await refreshDrawer();
        window.SLIDECART_OPEN();
      } else {
        location.assign(form.dataset.cartUrl);
      }
    } catch (error) {
      status.textContent = added ? form.dataset.added : error.message || form.dataset.error;
      form.setAttribute('data-feedback', '');
    } finally {
      form.removeAttribute('data-busy');
      form.setAttribute('aria-busy', 'false');
      button.disabled = false;
      button.textContent = originalLabel;
    }
  });
})();
